import { ArrayUtil } from '../../../../../utils/array.utils';
import { QueryKeysAndFnOptions } from '../hooks/useQueryKeysAndFnToCache/useQueryKeysAndFnToCache.types';

export default class OfflineDataDownloaderUtils {
  private static readonly NUMBER_OF_PARALLEL_REQUESTS = 3;

  static chunkByPriority(queryKeysAndFnToCache: QueryKeysAndFnOptions): QueryKeysAndFnOptions[] {
    const groupedByPriority = this.mapItemsByPriority(queryKeysAndFnToCache);
    const orderedGroups = this.sortChunkGroupsByPriority(groupedByPriority);
    return this.flatOrderedChunkGroups(orderedGroups);
  }

  private static mapItemsByPriority(
    queryKeysAndFnToCache: QueryKeysAndFnOptions,
  ): Map<number, QueryKeysAndFnOptions> {
    const itemsMappedByPriority = new Map<number, QueryKeysAndFnOptions>();

    for (const item of queryKeysAndFnToCache) {
      const priority = item.priority;

      if (itemsMappedByPriority.has(priority)) {
        itemsMappedByPriority.get(priority)?.push(item);
      } else {
        itemsMappedByPriority.set(priority, [item]);
      }
    }

    return itemsMappedByPriority;
  }

  private static sortChunkGroupsByPriority(
    itemsMappedByPriority: Map<number, QueryKeysAndFnOptions>,
  ): QueryKeysAndFnOptions[] {
    const itemsWithPriority = [...itemsMappedByPriority.entries()];
    const sortedEntries = itemsWithPriority.sort((a, b) => a[0] - b[0]);
    const chunkGroups = sortedEntries.map(([_priority, items]) => items);
    return chunkGroups;
  }

  private static flatOrderedChunkGroups(orderedGroups: QueryKeysAndFnOptions[]) {
    return orderedGroups.flatMap((group) =>
      ArrayUtil.chunk(group, this.NUMBER_OF_PARALLEL_REQUESTS),
    );
  }
}
